module.exports = __webpack_public_path__ + "img/invisible.9ec44d0b.jpeg";